export default __webpack_public_path__ + "static/media/comm 8.70e8d1c8.png";